<template>
	<div class="feature-block">
		<article class="feature-image-container">
      <FeatureCard
				:idx="idx"
				:title="title"
				:description="description"
			/>
			<FeatureImage
				:idx="idx"
				:img="img"
			/>
		</article>
	</div>
</template>

<script>
import FeatureImage from '@/components/LP/atoms/FeatureImage'
import FeatureCard from '@/components/LP/atoms/FeatureCard'

export default {
  name: 'FeatureBlock',
	components: {
		FeatureImage,
		FeatureCard
  },
  props: {
		idx: {
      type: Number,
      required: false,
      default: 0
		},
    img: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.feature-block {
  max-width: 1200px;
  width:95%;
  margin: auto;
  margin-bottom: 80px;
}
.feature-number {
	margin-right: 6px;
}
.feature-image-container {
	position: relative;
	margin: auto;
}

// deep selector
$image-width: 720px;
$image-height: 450px;
$card-width: 560px;
$card-height: 320px;

.feature-image-container /deep/ .feature-image {
  width: $image-width;
  height: $image-height;
}
.feature-image-container /deep/ .feature-card {
  width: $card-width;
  height: $card-height;
  top: ($image-height - $card-height) / 2;
}
@media screen and (max-width: 896px) {
  $image-width: 100%;
  $image-height: 100%;
  $card-width: 100%;
  $card-height: 100%;
  .feature-image-container /deep/ .feature-image {
    width: $image-width;
    height: $image-height;
  }
  .feature-image-container /deep/ .feature-card {
    width: $card-width;
    height: $card-height;
    top: ($image-height - $card-height) / 2;
  }
  .feature-image-container {
    display: flex;
    flex-direction: column-reverse;
  }
  .feature-block {
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/molecules/FeatureBlock.vue